// "מעבר ללוח התחרויות" under a coach reply (2026-10-27). Navigation only — nothing here changes a race or the plan.
// Conservative, no AI: the reply must RECOMMEND changing / cancelling / postponing / not taking part in a race, and the
// athlete must have a registered race within RACE_WINDOW_DAYS. A general mention of a race never qualifies:
//   "לשקול אי-השתתפות במרוץ מחר", "לוותר על המרוץ", "להימנע מהמרוץ", "לדחות את התחרות"      -> yes
//   "ממליץ לא להתחרות כדי לא להחמיר את הפציעה"                                                -> yes
//   "בהצלחה במרוץ מחר", "לבטל את האימון לפני המרוץ", "לא לרוץ מהר מדי במרוץ"               -> no
// The backend's race-day refusal ("…עדכן אותו במסך 'התחרויות שלי'…") always qualifies — it points there itself.

export const RACE_WINDOW_DAYS = 14;

// a change verb, then the race as its direct object: "לוותר על המרוץ", "להימנע מהמרוץ", "אי-השתתפות במרוץ"
const VERBS = '(?:לבטל|תבטל|לדחות|תדחה|לוותר|תוותר|להימנע|תימנע|לדלג|תדלג|לעדכן|לשנות'
  + '|לא\\s+להשתתף|לא\\s+תשתתף|שלא\\s+להשתתף|אי[-־\\s]?השתתפות|לא\\s+לרוץ|שלא\\s+לרוץ)';
const OBJECT = '\\s+(?:את\\s+|על\\s+|מ|ב)?(?:ה)?(?:השתתפות\\s+(?:שלך\\s+)?ב(?:ה)?)?';
const escapeRx = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

const POINTS_TO_RACES = /(התחרויות שלי|לוח התחרויות)/;
// "ממליץ לא להתחרות כדי לא להחמיר" (production, 2026-10-27): the verb itself is the race — no object needed. Never the
// everyday "competing with someone / at a pace" ("לא להתחרות עם אחרים", "לא להתחרות בקצב של הקבוצה").
const NOT_COMPETE = /(?:^|[^א-ת])(?:שלא|לא|אל)\s+(?:להתחרות|תתחרה)(?!\s+(?:עם|מול|נגד|בקצב|באימון|בעצמך))/;

/** Days from today (local calendar date) to an ISO race date; null when unparsable. */
export function daysUntil(raceDate, today = new Date()) {
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(raceDate || ''));
  if (!m) return null;
  const race = new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
  const day = new Date(today.getFullYear(), today.getMonth(), today.getDate());
  return Math.round((race - day) / 86400000);
}

/** Does this coach reply recommend changing the athlete's participation in an upcoming race? */
export function suggestsRaceChange(text, { nextRace = null, today = new Date() } = {}) {
  const t = String(text || '');
  if (!t) return false;
  if (POINTS_TO_RACES.test(t)) return true;
  const d = nextRace ? daysUntil(nextRace.race_date, today) : null;
  if (d === null || d < 0 || d > RACE_WINDOW_DAYS) return false;
  if (NOT_COMPETE.test(t)) return true;
  const name = String((nextRace && nextRace.race_name) || '').trim();
  const target = `(?:מרוץ|תחרות${name ? `|${escapeRx(name)}` : ''})`;
  return new RegExp(VERBS + OBJECT + target).test(t);
}
